module.exports = __webpack_public_path__ + "resources/img/img_hi_psm3_m_jp.9cf6bf13e2a14cae44e28dd20342ec56.png";